import React from 'react'
import { Controller, FieldName, Control } from 'react-hook-form'
import { DropInput } from '../DropInput'
import { ContentType, DocumentType } from '@mutual-services/account-documents-types'

export type HfDropInputProps<TFormValues> = {
  control: Control<TFormValues>,
  name: FieldName<TFormValues> | string,
  error?: string,
  fileTypes: ContentType[],
  label?: string,
  allowedDocumentTypes: DocumentType[],
  defaultValue?: File | null,
  completedAt?: Date | null | string,
  fieldArrayProps?: {
    remove: (index?: number) => void
  },
  canRemove?: boolean,
  hasOnlyOneFile?: boolean
}

export function HfDropInput<TFormValues> (props: React.PropsWithChildren<HfDropInputProps<TFormValues>>) {
  const { control, name, error, ...rest } = props
  return (
    <Controller
      name={name}
      control={control as any}
      render={({ field }) => (
        <DropInput
          {...rest}
          {...field}
          error={Boolean(error)}
          onBlur={field.onBlur}
          onChange={(ev) => field.onChange(ev.target.value)}
        />
      )}
    />
  )
}
